import { Box, CircularProgress } from '@ltvco/refresh-lib/theme';
import { Fade } from '@mui/material'; // TODO: Fade not exported from @ltvco/refresh-lib/theme
import React from 'react';

import {
  PaginationOverlayContainer,
  paginationOverlayCardStyles,
} from './components';

export interface PaginationOverlayProps {
  isVisible: boolean;
}

export const PaginationOverlay: React.FC<PaginationOverlayProps> = ({
  isVisible,
}) => (
  <Fade in={isVisible}>
    <PaginationOverlayContainer
      sx={{
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <Box sx={paginationOverlayCardStyles}>
        <CircularProgress size={32} />
      </Box>
    </PaginationOverlayContainer>
  </Fade>
);
